(function ($, window) {
	let product_logo_management = {
		toggle_checkbox_selector: '.toggle-form-js',
		logo_value_element: '.prodigy-logo-values-js',
		template_selector: '#logo-form-template',
		main_logo_management_container: '.logo-container-js',
		block_logo_management_container: '.container-js',
		logo_options_ids: [],
		// logo can be just for the 'color' attribute
		logo_attribute: 'color',
		prodigy_product_swatch_block_element: '.prodigy-product__swatch-block-js',
		is_logo_swatches: false,

		init: function () {
			if (this.is_logo()) {
				this.set_logo_showing_type();
				this.update_forms_visibility();
				this.show_logo_form();
				this.update_required_id();
				this.rewire_swatch_ids(document);
				this.wire_logo_block_ids();
				this.update_aria_attr();
				if (this.is_logo_swatches) {
					if (typeof prodigyProductBulk !== 'undefined' && !prodigyProductBulk.is_active_logo_bulk) {
						this.refreshNonBulkLogoSwatchVisibility();
					}
					this.set_logos_swatches();
				} else {
					this.set_logos();
				}
				this.change_logo_radio();

				this.set_custom_location_select();
				this.set_custom_logo_select();

				if (!prodigyProduct.is_variants() && !this.is_logo_swatches) {
					this.set_logos();
				}
				this.update_extra_location_charges();
				this.refresh_product_price_and_variant_info();

				this.open_tooltip_mobile();
				this.close_tooltip_mobile();
			}
		},

		is_option_has_logo: function (option_id) {
			let logo_images_options = this.get_logos_data_by_option();
			let isFound = false;

			for (const key in logo_images_options) {
				if (parseInt(logo_images_options[key].option_id) === parseInt(option_id)) {
					isFound = true;
					break;
				}
			}

			return isFound;
		},

		is_option_has_required_logo: function (option_slug) {
			let logo_images_options = this.get_logos_data_by_option(option_slug);
			let isFound = false;

			for (const key in logo_images_options) {
				if (logo_images_options[key].location.required) {
					isFound = true;
					break;
				}
			}

			return isFound;
		},

		is_option_has_image: function (attribute, option_slug) {
			let images_options = this.get_logos_data();
			let isFound = false;

			for (const key in images_options[attribute]) {
				if (key === option_slug) {
					if (typeof images_options[attribute][key].images !== 'undefined') {
						isFound = true;
						break;
					}
				}
			}

			return isFound;
		},

		is_logo_activated: function () {
			return $('.prodigy-logo-tool__container.opened').length > 0;
		},

		is_logo: function () {
			let result = false;
			if (typeof $('#product-logos-data-js').val() !== 'undefined') {
				let data = JSON.parse($('#product-logos-data-js').val());
				result = data.length !== 0;
			}

			return result;
		},

		/**
		 * Extra location from another brand (AJAX second block). Active only when PHP outputs
		 * data-extra-brand-mode="1" — i.e. Support multiple locations is off, both admin brand
		 * selects are set, URL ?brand= matches scope brand. All other products use legacy logo logic.
		 */
		is_extra_brand_url_scoped_mode: function ($el) {
			if (!$el || !$el.length) {
				return false;
			}
			return $el.closest('.logo-container-js').is('[data-extra-brand-mode="1"]');
		},

		/**
		 * The "Add one more logo" row is a second .prodigy-logo-tool__container with .prodigy-logo-extra-brand-block-js.
		 * It must not be treated as a multi-location clone or removed by update_forms_visibility.
		 */
		is_extra_brand_logo_tool_container: function ($container) {
			return $container && $container.length && $container.find('.prodigy-logo-extra-brand-block-js').length > 0;
		},

		set_default_location_logos: function () {
			let self = this;
			let logo_images_options = self.get_not_required_locations();
			if (typeof logo_images_options !== 'undefined') {
				if (logo_images_options && logo_images_options.length && logo_images_options.length === 0) {
					return;
				}

				if (Object.entries(logo_images_options).length > 0) {
					let default_logo_location = Object.entries(logo_images_options)[0][1];
					for (let i in logo_images_options) {
						if (logo_images_options[i].is_default) {
							default_logo_location = logo_images_options[i];
							break;
						}
					}

					let $container = $('.prodigy-logo-tool__container.opened').first();
					let default_location_id = default_logo_location.location_id;
					let default_logo_id = default_logo_location.logo_id;

					let $location_select = $container.find('.prodigy-logo-location-js');
					this.set_location_select_value($location_select, default_location_id);
					self.enable_required_selected_location($location_select, default_location_id);
					if (self.is_logo_swatches) {
						self.show_logos_swatches_by_location($container, logo_images_options, default_location_id);
						self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), default_logo_id);
					} else {
						self.show_logos_dropdown_by_location($container, logo_images_options, default_location_id, default_logo_id);
					}

					let preselected_location_ids = self.get_selected_locations_list($location_select);
					self.refresh_locations_list($location_select, logo_images_options, preselected_location_ids);
					self.update_main_gallery_images(default_logo_location.logo_id, default_location_id, null, $container);
				}
			}
		},

		hide_logo_swatch_by_logo_id: function ($container, logo_id) {
			const esc = String(logo_id).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
			const $logo_swatch = $container.find('.prodigy-product__logo-swatch-js[value="' + esc + '"]');
			$logo_swatch.prop('disabled', 'disabled');
			$logo_swatch.closest('.prodigy-tooltip-js').addClass('prodigy-logo__disabled');
			$logo_swatch.closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').addClass('prodigy-logo__disabled-mobile');
		},

		show_logo_swatch_by_logo_id: function ($container, logo_id) {
			const esc = String(logo_id).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
			const $logo_swatch = $container.find('.prodigy-product__logo-swatch-js[value="' + esc + '"]');
			$logo_swatch.removeAttr('disabled');
			$logo_swatch.closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
			$logo_swatch.closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
		},

		show_logos_swatches_by_location: function ($container, image_logos_settings, location_id, color_option_id) {
			let self = this;
			const cid = typeof color_option_id === 'undefined' ? null : color_option_id;
			$container.find('.prodigy-product__logo-swatch-js').each(function () {
				let logo_id = $(this).val();
				if (self.is_isset_logo_location_in_data(image_logos_settings, location_id, logo_id, cid)) {
					self.show_logo_swatch_by_logo_id($container, logo_id);
				} else {
					self.hide_logo_swatch_by_logo_id($container, logo_id);
				}
			});
		},

		show_logos_dropdown_by_location: function ($container, image_logos_settings, location_id, logo_id) {
			let self = this;
			$container.find('.prodigy-logo-values-js option').each(function () {
				let opt_logo_id = $(this).val();
				const $logo_option = $(this);
				if (self.is_isset_logo_location_in_data(image_logos_settings, location_id, opt_logo_id)) {
					$logo_option.prop('disabled', false);
					$logo_option.prop('selected', true);
				} else {
					$logo_option.prop('disabled', true);
					$logo_option.prop('selected', false);
				}
			});

			if (logo_id) {
				$container.find('.prodigy-logo-values-js').find('option[value="' + logo_id + '"]').prop('selected', true);
			}
			self.refresh_ms_logo_dropdown($container.find('.prodigy-logo-values-js'));
		},

		refresh_ms_logo_dropdown: function ($container) {
			if ($container.get(0) && typeof $container.get(0).msDropdown !== 'undefined') {
				$container.get(0).msDropdown.refresh();
			} else {
				this.set_custom_logo_select();
			}
		},

		refresh_ms_location_dropdown: function ($container) {
			if ($container.get(0) && typeof $container.get(0).msDropdown !== 'undefined') {
				$container.get(0).msDropdown.refresh();
			} else {
				this.set_custom_location_select();
			}
		},

		is_isset_location_in_data: function (image_logos_settings, location_id) {
			let isFound = false;
			for (const key in image_logos_settings) {
				if (parseInt(image_logos_settings[key].location_id) === parseInt(location_id) &&
					image_logos_settings[key].location.required
				) {
					isFound = true;
					break;
				}
			}

			return isFound;
		},

		is_isset_logo_location_in_data: function (image_logos_settings, location_id, logo_id, color_option_id) {
			let isFound = false;
			const colorOpt = color_option_id !== null && color_option_id !== undefined && String(color_option_id) !== ''
				? parseInt(color_option_id, 10)
				: null;
			for (const key in image_logos_settings) {
				const row = image_logos_settings[key];
				if (parseInt(row.location_id, 10) !== parseInt(location_id, 10)) {
					continue;
				}
				if (logo_id !== null && logo_id !== undefined && parseInt(row.logo_id, 10) !== parseInt(logo_id, 10)) {
					continue;
				}
				if (colorOpt !== null && !isNaN(colorOpt) && colorOpt > 0) {
					if (typeof row.option_id === 'undefined' || parseInt(row.option_id, 10) !== colorOpt) {
						continue;
					}
				}
				isFound = true;
				break;
			}

			return isFound;
		},

		resolveColorOptionIdForLogoSwatchFilter: function ($toolContainer) {
			if ($toolContainer && $toolContainer.length && this.is_extra_brand_logo_tool_container($toolContainer)) {
				return this.getSelectedLogoColorOptionId();
			}
			return null;
		},

		refreshNonBulkLogoSwatchVisibility: function () {
			let self = this;
			if (!self.is_logo_swatches || prodigyProductBulk.is_active_logo_bulk) {
				return;
			}
			$('.prodigy-logo-tool__container.opened').each(function () {
				const $tool = $(this);
				const $form = $tool.find('.prodigy-logo-tool__form-container').first();
				if (!$form.length) {
					return;
				}
				const overlay = self.get_logos_overlay_settings_for_container($tool);
				const locId = $tool.find('.prodigy-logo-location-js').first().val();
				const colorOpt = self.resolveColorOptionIdForLogoSwatchFilter($tool);
				self.show_logos_swatches_by_location($form, overlay, locId, colorOpt);
				const $checked = $form.find('.prodigy-product__logo-swatch-js:checked');
				if (!$checked.length || $checked.prop('disabled')) {
					const $first = $form.find('.prodigy-product__logo-swatch-js:not(:disabled)').first();
					if ($first.length) {
						$first.prop('checked', true);
						const nm = $first.data('name');
						if (nm) {
							$tool.find('.swatch-logo-name-js').first().text(nm);
						}
					}
				}
			});
		},

		getColorOptionIdFromProductOptionsData: function () {
			const attr = this.logo_attribute;
			let colorSlug = null;
			if (this.is_swatches()) {
				let $sw = $('.prodigy-product__swatch-block-js:not(.ignored) .prodigy-product__swatch-js[data-attribute="' + attr + '"]:checked').first();
				if (!$sw.length) {
					$sw = $('.prodigy-product__swatch-js[data-attribute="' + attr + '"]:checked').first();
				}
				if ($sw.length) {
					colorSlug = $sw.data('slug');
				}
			} else {
				const $sel = $('.attribute_values_js[data-slug="' + attr + '"] option:selected');
				if ($sel.length) {
					colorSlug = $sel.data('slug');
				}
			}
			if (!colorSlug) {
				return 0;
			}
			try {
				const product_options = this.get_logos_data();
				if (!product_options || !product_options[attr] || !product_options[attr][colorSlug]) {
					return 0;
				}
				const block = product_options[attr][colorSlug];
				if (block && block.option_id !== undefined && block.option_id !== null && block.option_id !== '') {
					const p = parseInt(block.option_id, 10);
					return isNaN(p) ? 0 : p;
				}
			} catch (e) {}
			return 0;
		},

		hide_all_logo_blocks: function () {
			$('.prodigy-logo-tool__container.opened').hide();
		},

		set_logo_showing_type: function () {
			this.is_logo_swatches = $('.prodigy-product__logo-swatch-js').length > 0;
		},

		/**
		 * Master logo overlay rows for the primary (URL) brand, or from extra-brand AJAX payload inside .prodigy-logo-extra-brand-block-js.
		 */
		get_logos_overlay_settings_for_container: function ($toolContainer, option_slug) {
			if (!$toolContainer || !$toolContainer.length) {
				return this.get_logos_data_by_option(option_slug);
			}
			if (!this.is_extra_brand_url_scoped_mode($toolContainer)) {
				return this.get_logos_data_by_option(option_slug);
			}
			const $extraRoot = $toolContainer.find('.prodigy-logo-extra-brand-block-js').first();
			if (!$extraRoot.length) {
				return this.get_logos_data_by_option(option_slug);
			}
			const $inp = $extraRoot.find('input.prodigy-extra-brand-master-logos-js').first();
			if (!$inp.length) {
				return [];
			}
			try {
				const raw = $inp.val();
				if (!raw) {
					return [];
				}
				const parsed = JSON.parse(raw);
				if (typeof parsed !== 'object' || parsed === null) {
					return [];
				}
				// Must keep object keys: they are logo-option relation ids for the cart API.
				// Object.values() would turn { "12345": row, "67890": row } into an array and
				// get_logo_options would push 0,1 instead of 12345,67890 → "logo option is missing for this variant".
				return parsed;
			} catch (e) {
				return [];
			}
		},

		update_main_gallery_images: function (logo_id, location_id, option_slug=null, $toolContainer=null) {
			let self = this;
			const options = $toolContainer && $toolContainer.length
				? self.get_logos_overlay_settings_for_container($toolContainer, option_slug)
				: self.get_logos_data_by_option(option_slug);
			const $current_image = $('#gallery-main .swiper-slide-active .main-gallery-image-js');
			let is_image_available = false;
			for (let i in options) {
				if (parseInt(options[i].logo_id) === parseInt(logo_id)
					&& parseInt(options[i].location_id) === parseInt(location_id)
					&& parseInt(options[i].image_id) === $current_image.data('image-id')
				) {
					is_image_available = true;
					break;
				}
			}

			if (!is_image_available) {
				let image_id;
				for (let i in options) {
					if (parseInt(options[i].logo_id) === parseInt(logo_id)
						&& parseInt(options[i].location_id) === parseInt(location_id)
					) {
						image_id = options[i].image_id;
					}
				}

				for (let j in prodigyProductGallery.swiperMain.slides) {
					const slide_image_id = $(prodigyProductGallery.swiperMain.slides[j]).find('.main-gallery-image-js').data('image-id');
					if (parseInt(slide_image_id) === parseInt(image_id)) {
                        prodigyProductGallery.swiperMain.slideTo(j);
					}
				}
			}
		},

		update_forms_visibility: function (option_slug=null) {
			let self = this;
			const max_form_number = self.get_max_add_logo_forms(option_slug);
			let close_forms_number = $('.prodigy-logo-tool__container.opened').length - 1;
			if (self.is_extra_brand_url_scoped_mode($(self.main_logo_management_container).first())) {
				const $extraOpened = $('.prodigy-logo-tool__container.opened').filter(function () {
					return self.is_extra_brand_logo_tool_container($(this));
				});
				if ($extraOpened.length) {
					close_forms_number = Math.max(0, close_forms_number - 1);
				}
			}

			if (max_form_number > 1 && $('.prodigy-logo-tool__container.closed').length === 0) {
				if (!self.is_extra_brand_url_scoped_mode($(self.main_logo_management_container).first())) {
					let $clone = $(self.template_selector).contents().clone();
					$(self.main_logo_management_container).append($clone);
					this.set_custom_logo_select();
				}
			}

			//TODO - this code removing swatch logos form
			if (close_forms_number > 0 && !prodigyProductBulk.is_active_logo_bulk) {
				for (let i = 1; i <= close_forms_number; i++) {
					let $last_form = $('.prodigy-logo-tool__container.opened:last');
					if (self.is_extra_brand_logo_tool_container($last_form)) {
						break;
					}
					$last_form.remove();
				}
			}

			if ($('.prodigy-logo-tool__container').length === 1 && max_form_number > 0) {
				$('.prodigy-logo-tool__container').removeClass('closed');
				$('.prodigy-logo-tool__container').addClass('opened');
			}

			if ($('.prodigy-logo-tool__container.opened').length === max_form_number) {
				$('.prodigy-logo-tool__container.closed').each(function () {
					const $row = $(this);
					if (!self.is_extra_brand_logo_tool_container($row)) {
						$row.remove();
					}
				});
			}

			$('.prodigy-logo-tool__container.opened:first').find('.prodigy-logo-tool__toggler-block').remove();
			let image_logos_settings = self.get_logos_data_by_option(option_slug);
			const required_locations_set = self.get_required_locations_set(image_logos_settings);
			if (required_locations_set.size > 0) {
				self.show_required_locations(required_locations_set, option_slug);
			} else {
				self.set_default_location_logos();
			}
		},

		show_required_locations: function (required_locations_set, option_slug) {
			const self = this;
			const $logo_management_container = $(self.main_logo_management_container);

			let option = null;
			if (typeof option_slug !== 'undefined') {
				option = option_slug;
			}
			const logo_images_options = self.get_logos_data_by_option(option);
			$logo_management_container.find('.prodigy-logo-tool__container.opened').remove();
			const not_required_locations = self.get_not_required_locations(option_slug);

			let new_required_locations_set = new Set(required_locations_set);
			const reversedArray = Array.from(new_required_locations_set).reverse();
			const reversedSet = new Set(reversedArray);

			for (const location_id of reversedSet) {
				let $clone = $(self.template_selector).contents().clone();
				$clone.find('.prodigy-logo-tool__toggler-block').remove();
				$clone.removeClass('closed').addClass('required opened');
				$clone.find('.prodigy-product-location-block-js').addClass('prodigy-product__logo-location--required');

				if (not_required_locations.length === 0) {
					self.hide_add_more_logo_switcher();
				}

				self.disable_required_selected_location(location_id);
				$logo_management_container.prepend($clone);
				let $location_select = $clone.find('.prodigy-logo-location-js');
				self.set_location_select_value($location_select, location_id);
				let preselected_location_ids = self.get_selected_locations_list($location_select);

				if (!prodigyProductBulk.is_active_logo_bulk) {
					self.refresh_locations_list($location_select, logo_images_options, preselected_location_ids);
				}
				if (self.is_logo_swatches) {
					self.show_logos_swatches_by_location($clone, logo_images_options, location_id, null);
					let default_logo_id = self.get_default_logo_by_location(logo_images_options, location_id, null);
					self.set_swatch_logo_value($clone.find('.prodigy-product__logo-swatch-js'), default_logo_id);
				} else {
					self.show_logos_dropdown_by_location($clone, logo_images_options, location_id);
				}

				let logo_id = self.get_logo_data_by_location_id(logo_images_options, location_id);
				self.update_main_gallery_images(logo_id, location_id, null, $clone);
			}
		},

		hide_add_more_logo_switcher: function () {
			$('.prodigy-logo-tool__container.container-js.closed').hide();
		},

		get_logo_data_by_location_id: function (logo_images_options, location_id) {
			for (let i in logo_images_options) {
				if (logo_images_options[i].location_id === location_id) {
					return logo_images_options[i].logo_id;
				}
			}
		},

		get_required_locations_set: function (images_logos_settings) {
			let location_data = [];
			let location_set = new Set();

			for (let i in images_logos_settings) {
				if (!images_logos_settings[i].location.required) {
					continue;
				}

				let location_id = images_logos_settings[i].location_id;
				let location_position = images_logos_settings[i].location.position;

				if (!location_set.has(location_id)) {
					location_set.add(location_id);
					location_data.push({
						location_id: location_id,
						location_position: location_position
					});
				}
			}

			location_data.sort((a, b) => a.location_position - b.location_position);

			return new Set(location_data.map(item => item.location_id));
		},

		get_locations_set: function (images_logos_settings) {
			let location_set = new Set();
			for (let i in images_logos_settings) {
				let location_id = parseInt(images_logos_settings[i].location_id, 10);
				if (isNaN(location_id)) {
					continue;
				}
				if (!location_set.has(location_id)) {
					location_set.add(location_id);
				}
			}
			return location_set;
		},

		get_locations_set_from_select: function ($location_select) {
			const location_set = new Set();
			$location_select.find('option').each(function () {
				const location_id = parseInt($(this).attr('value'), 10);
				if (!isNaN(location_id)) {
					location_set.add(location_id);
				}
			});
			return location_set;
		},

		find_suitable_logo_location: function (images_logos_settings, default_logo_id, excluded_location_ids) {
			for (let i in images_logos_settings) {
				let is_location_available = !excluded_location_ids.includes(parseInt(images_logos_settings[i].location_id));
				let is_same_logo = false;
				if (typeof default_logo_id === 'undefined' || parseInt(images_logos_settings[i].logo_id) === parseInt(default_logo_id)) {
					is_same_logo = true;
				}
				if (is_same_logo && is_location_available) {
					return images_logos_settings[i];
				}
			}

			for (let i in images_logos_settings) {
				let is_location_available = !excluded_location_ids.includes(parseInt(images_logos_settings[i].location_id));
				if (is_location_available) {
					return images_logos_settings[i];
				}
			}

			return null;
		},

		update_locations_availability: function (attribute_name) {
			let self = this;

			$('.prodigy-logo-tool__container.opened').each(function () {
				let $container = $(this);
				const image_logos_settings = self.get_logos_overlay_settings_for_container($container, attribute_name);
				let $location_select = $container.find('.prodigy-logo-location-js');
				let preselected_location_ids = self.get_selected_locations_list($location_select);
				let location_set = self.get_locations_set(image_logos_settings);
				$location_select.find('option').attr('disabled', true);
				for (const location_id of location_set) {
					if (!preselected_location_ids.includes(location_id)) {
						$location_select.find('option[value="' + location_id + '"]').attr('disabled', false);
					}
				}
				self.disable_logos_with_no_locations($container, image_logos_settings);
			});
		},

		is_available_logo_location: function (logo_id, location_id, preselected_logo_location, image_logos_settings) {
			if (preselected_logo_location.includes(location_id)) {
				return false;
			}
			for (let i in image_logos_settings) {
				if (parseInt(image_logos_settings[i].logo_id) === parseInt(logo_id) && parseInt(image_logos_settings[i].location_id) === parseInt(location_id)) {
					return true;
				}
			}

			return false;
		},

		is_empty_logo_overlay_settings: function (s) {
			if (s === null || typeof s === 'undefined') {
				return false;
			}
			if (Array.isArray(s)) {
				return s.length === 0;
			}
			if (typeof s === 'object') {
				return Object.keys(s).length === 0;
			}
			return false;
		},

		refresh_locations_list: function ($location_select, image_logos_settings, preselected_location_ids) {
			let self = this;
			let location_set = self.get_locations_set(image_logos_settings);
			const isExtraBrandLocation = $location_select.closest('.prodigy-logo-extra-brand-block-js').length > 0;
			if (!location_set.size && isExtraBrandLocation && self.is_empty_logo_overlay_settings(image_logos_settings)) {
				$location_select.find('option[value!=""]').prop('disabled', true);
				self.refresh_ms_location_dropdown($location_select);
				$location_select.closest('.prodigy-product-location-block-js').hide();
				return;
			}
			if (!location_set.size) {
				location_set = self.get_locations_set_from_select($location_select);
			}
			let selected_location_id = parseInt($location_select.val());
			if (preselected_location_ids.includes(selected_location_id) || !location_set.has(selected_location_id)) {
				for (const location_id of location_set) {
					if (!preselected_location_ids.includes(location_id)) {
						selected_location_id = location_id;
						break;
					}
				}
			}

			if (isExtraBrandLocation) {
				$location_select.closest('.prodigy-product-location-block-js').show();
				// MsDropdown may still render hidden/disabled options, so rebuild the select list
				// from the initial source and keep only currently available locations.
				const originalOptions = $location_select.data('original-options-html') || $location_select.html();
				if (!$location_select.data('original-options-html')) {
					$location_select.data('original-options-html', originalOptions);
				}
				const $tmpSelect = $('<select>' + originalOptions + '</select>');
				const available = [];
				for (const location_id of location_set) {
					if (!preselected_location_ids.includes(location_id)) {
						available.push(String(location_id));
					}
				}
				$tmpSelect.find('option').each(function () {
					const val = String($(this).val() || '');
					if (val !== '' && available.indexOf(val) === -1) {
						$(this).remove();
					}
				});
				$location_select.html($tmpSelect.html());
				if (available.indexOf(String(selected_location_id)) === -1 && available.length) {
					selected_location_id = parseInt(available[0], 10);
				}
				$location_select.val(selected_location_id);
				self.refresh_ms_location_dropdown($location_select);
				return;
			}

			$location_select.find('option').prop('disabled', true);
			for (const location_id of location_set) {
				if (!preselected_location_ids.includes(location_id)) {
					$location_select.find('option[value="' + location_id + '"]').prop('disabled', false);
				}
			}
			$location_select.val(selected_location_id);
			self.refresh_ms_location_dropdown($location_select);
		},

		preselect_logo_by_location: function ($container, images_logos_settings, location_id) {
			let self = this;
			const $tool = $container.closest('.prodigy-logo-tool__container');
			const colorOpt = self.resolveColorOptionIdForLogoSwatchFilter($tool);
			let default_logo_id = self.get_first_logo_by_location(images_logos_settings, location_id, colorOpt);

			if (self.is_logo_swatches) {
				self.show_logos_swatches_by_location($container, images_logos_settings, location_id, colorOpt);
				self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), default_logo_id);
			} else {
				self.show_logos_dropdown_by_location($container, images_logos_settings, location_id);
			}
		},

		disable_logos_with_no_locations: function ($container, image_logos_settings) {
			let self = this;
			if (self.is_logo_swatches) {
				self.disable_logos_swatches_with_no_locations($container, image_logos_settings);
				return;
			}

			let $location_select = $container.find('.prodigy-logo-location-js');
			let preselected_location_ids = self.get_selected_locations_list($location_select);

			$container.find('.prodigy-logo-values-js option').each(function () {
				let is_empty_locations = true;
				for (let i in image_logos_settings) {
					if (parseInt(image_logos_settings[i].logo_id) === parseInt($(this).attr('value')) && !preselected_location_ids.includes(parseInt(image_logos_settings[i].location_id))) {
						is_empty_locations = false;
						break;
					}
				}

				$(this).prop('disabled', is_empty_locations);
			});
		},

		disable_logos_swatches_with_no_locations: function ($container, image_logos_settings) {
			let $location_select = $container.find('.prodigy-logo-location-js');
			let preselected_location_ids = this.get_selected_locations_list($location_select);

			$container.find('.prodigy-product__logo-swatch-js').each(function () {
				let is_empty_locations = true;
				for (let i in image_logos_settings) {
					if (parseInt(image_logos_settings[i].logo_id) === parseInt($(this).val()) && !preselected_location_ids.includes(parseInt(image_logos_settings[i].location_id))) {
						is_empty_locations = false;
						break;
					}
				}

				$(this).prop('disabled', is_empty_locations);

				if (is_empty_locations) {
					$(this).closest('.prodigy-tooltip-js').addClass('prodigy-logo__disabled');
					$(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').addClass('prodigy-logo__disabled-mobile');
				} else {
					$(this).closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
					$(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
				}
			});
		},

		open_tooltip_mobile: function () {
			$(document).on('click', '.prodigy-logo__disabled-mobile', function (e) {
				e.preventDefault();
				let $tooltip = $(this).closest('.prodigy-tooltip-js').find('.prodigy-tooltip__message');
				let $backdrop = $(this).closest('.prodigy-tooltip-js').find('.prodigy-after__backdrop');

				$tooltip.addClass('d-flex');
				$backdrop.show();
			});
		},

		close_tooltip_mobile: function () {
			$(document).on('click', '.prodigy-after__backdrop', function () {
				let $tooltip = $(this).closest('.prodigy-tooltip-js').find('.prodigy-tooltip__message');

				$tooltip.removeClass('d-flex');
				$(this).hide();
			});
		},

		set_location_select_value: function ($location_select, value) {
			let self = this;
			$location_select.val(value);
			$location_select.removeAttr('disabled');
			self.refresh_ms_location_dropdown($location_select);
		},

		set_swatch_logo_value: function ($logo_radio, value) {
			$logo_radio.filter('[value="' + value + '"]').prop('checked', 'checked');
		},

		set_logo_select_value: function ($logo_select, value) {
			let self = this;
			$logo_select.val(value);
			self.refresh_ms_logo_dropdown($logo_select);
		},

		disable_selected_location: function () {
			const self = this;

			if ($('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').length < 2) {
				return;
			}

			const syncExtraBrandLocation = function ($location_select) {
				const $toolContainer = $location_select.closest('.prodigy-logo-tool__container');
				const images_logos_settings = self.get_logos_overlay_settings_for_container($toolContainer);
				const preselected_location_ids = self.get_selected_locations_list($location_select);
				self.refresh_locations_list($location_select, images_logos_settings, preselected_location_ids);
				const locVal = $location_select.val();
				const $formContainer = $location_select.closest('.prodigy-logo-tool__form-container');
				self.preselect_logo_by_location($formContainer, images_logos_settings, locVal);
				let logo_id;
				if (self.is_logo_swatches) {
					logo_id = $formContainer.find('.prodigy-product__logo-swatch-js:checked').val();
				} else {
					logo_id = $formContainer.find('.prodigy-logo-values-js').val();
				}
				self.update_main_gallery_images(logo_id, locVal, null, $toolContainer);
			};

			const syncPrimaryOrCloneLocation = function ($location_select) {
				const $toolContainer = $location_select.closest('.prodigy-logo-tool__container');
				const images_logos_settings = self.get_logos_overlay_settings_for_container($toolContainer);
				const preselected_location_ids = self.get_selected_locations_list($location_select);
				const location_set = self.get_locations_set(images_logos_settings);
				for (const lid of location_set) {
					const location_id = parseInt(lid, 10);
					const $location_option = $location_select.find('option[value="' + location_id + '"]');
					if (!$location_option.length) {
						continue;
					}
					if (!preselected_location_ids.includes(location_id)) {
						$location_option.prop('disabled', false);
					} else {
						$location_option.prop('disabled', true);
					}
				}
				self.refresh_ms_location_dropdown($location_select);
			};

			// Resolve extra-brand row first so primary row is not toggled using a stale duplicate location.
			$('.prodigy-logo-tool__container.opened .prodigy-logo-extra-brand-block-js .prodigy-logo-location-js').each(function () {
				syncExtraBrandLocation($(this));
			});

			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').filter(function () {
				return $(this).closest('.prodigy-logo-extra-brand-block-js').length === 0;
			}).each(function () {
				syncPrimaryOrCloneLocation($(this));
			});
		},

		disable_required_selected_location: function (location_id) {
			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').each(function () {
				const $location_select = $(this);
				const $location_option = $location_select.find('option[value="' + location_id + '"]');
				$location_option.prop('disabled', true);
			});
		},

		enable_required_selected_location: function ($location_select, location_id) {
			$location_select.find('option[value="' + location_id + '"]').prop('disabled', false);
			$location_select.closest('.prodigy-product-location-block-js').removeClass('prodigy-product__logo-location--required');
			this.refresh_ms_location_dropdown($(this));
		},

		enable_selected_location: function (location_id) {
			let self = this;
			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').each(function () {
				if (parseInt($(this).val()) !== parseInt(location_id)) {
					$(this).find('option[value="' + location_id + '"]').attr('disabled', false);
				}

				self.refresh_ms_location_dropdown($(this));
			});
		},

		change_logo_radio: function () {
			let self = this;
			$(document).on('click', '.prodigy-product__logo-swatch-js', function () {
				let $container = $(this).closest('.prodigy-logo-tool__form-container');
				let logo_id = $container.find('.prodigy-product__logo-swatch-js:checked').val();
				self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), logo_id);

				let bulk_option_slug = '';
				if (prodigyProductBulk.is_active_logo_bulk) {
					$('.prodigy-bulk-input-js').filter(function() {
						if ($(this).val() !== '') {
							bulk_option_slug = $(this).data('option');
							if (product_logo_management_object.is_option_has_required_logo(bulk_option_slug)){
								self.set_logos_swatches(bulk_option_slug);
								let $bulkTool = $(this).closest('.prodigy-logo-tool__container');
								let location_select = $bulkTool.find('.prodigy-logo-location-js');
								self.update_main_gallery_images(logo_id, location_select.val(), bulk_option_slug, $bulkTool);

								self.refresh_product_price();
							} else {
								$(document).trigger('enable-multiple-quantity');
							}
						}
					});
					$(document).trigger('enable-multiple-quantity');
				} else {
					self.set_logos_swatches();
				}

				let $tool = $(this).closest('.prodigy-logo-tool__container');
				let location_select = $tool.find('.prodigy-logo-location-js');
				self.update_main_gallery_images(logo_id, location_select.val(), bulk_option_slug, $tool);

				self.refresh_product_price();

			});
		},

		get_not_empty_bulk_input: function () {
			$('.prodigy-bulk-input-js').filter(function() {
				if ($(this).val() !== '') {
					return $(this);
				}
			});
		},

		set_custom_logo_select: function () {
			let self = this;
			let dropdownOpened = false;
			MsDropdown.make('.prodigy-logo-values-js:not(.inited)', {
				enableAutoFilter: false,
				on: {
					open: function () {
						dropdownOpened = true;
					},
					change: function (data) {
						if (dropdownOpened) {
							dropdownOpened = false;
							let bulk_option_slug = '';
								if (prodigyProductBulk.is_active_logo_bulk) {
									$('.prodigy-bulk-input-js').filter(function() {
										if ($(this).val() !== '') {
											bulk_option_slug = $(this).data('option');
											if (self.is_option_has_required_logo(bulk_option_slug)){
												self.set_logos(bulk_option_slug);
												let $ltBulk = $(data.option).closest('.prodigy-logo-tool__container');
												self.update_main_gallery_images(data.data.value, $ltBulk.find('.prodigy-logo-location-js').val(), bulk_option_slug, $ltBulk);

												self.refresh_product_price();
											} else {
												$(document).trigger('enable-multiple-quantity');
											}
										}
									});
									$(document).trigger('enable-multiple-quantity');
								} else {
									self.set_logos(bulk_option_slug);
								}
							let $logoTool = $(data.option).closest('.prodigy-logo-tool__container');
							let location_select = $logoTool.find('.prodigy-logo-location-js');
							self.update_main_gallery_images(data.data.value, location_select.val(), null, $logoTool);
							self.refresh_product_price_and_variant_info();
						}
					},
					close: function () {
						self.refresh_product_price();
					},
				},
			});
			$('.prodigy-logo-values-js:not(.inited)').addClass('inited');
		},

		set_custom_location_select: function () {
			let self = this;
			let dropdownOpened = false;
			MsDropdown.make('.prodigy-logo-location-js:not(.inited)', {
				enableAutoFilter: false,
				on: {
					enableAutoFilter: false,
					open: function () {
						dropdownOpened = true;
					},
					change: function (data) {
						if (prodigyProductBulk.is_active_logo_bulk) {
							$(document).trigger('enable-multiple-quantity');
						} else {
							if (dropdownOpened) {
								let $container = $(data.option).closest('.prodigy-logo-tool__container.opened');
								if (self.is_logo_activated()) {
									let location_id = data.data.value;
									let logo_images_options = self.get_logos_overlay_settings_for_container($container, null);
									const colorOpt = self.resolveColorOptionIdForLogoSwatchFilter($container);
									let logo_id = self.get_default_logo_by_location(logo_images_options, location_id, colorOpt)
										|| self.get_first_logo_by_location(logo_images_options, location_id, colorOpt);
									if (self.is_logo_swatches) {
										self.show_logos_swatches_by_location($container, logo_images_options, location_id, colorOpt);
										if (logo_id) {
											self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), logo_id);
										}
										self.set_logos_swatches();
									} else {
										self.show_logos_dropdown_by_location($container, logo_images_options, location_id, logo_id);
										self.set_logos();
									}
									self.update_main_gallery_images(logo_id, location_id);
									self.disable_selected_location(location_id);
								}

								self.refresh_product_price();
							}
							dropdownOpened = false;
						}
					},
				},
			});
			$('.prodigy-logo-location-js:not(.inited)').addClass('inited');
		},

		get_first_logo_by_location: function (logo_images_options, location_id, color_option_id) {
			const loc = parseInt(location_id, 10);
			if (isNaN(loc)) {
				return;
			}
			const colorOpt = color_option_id !== undefined && color_option_id !== null && String(color_option_id) !== ''
				? parseInt(color_option_id, 10)
				: null;
			for (let i in logo_images_options) {
				const row = logo_images_options[i];
				if (parseInt(row.location_id, 10) !== loc) {
					continue;
				}
				if (colorOpt !== null && !isNaN(colorOpt) && colorOpt > 0) {
					if (typeof row.option_id === 'undefined' || parseInt(row.option_id, 10) !== colorOpt) {
						continue;
					}
				}
				return row.logo_id;
			}
		},

		get_default_logo_by_location: function (logo_images_options, location_id, color_option_id) {
			let first_available_logo_id;
			const loc = parseInt(location_id, 10);
			if (isNaN(loc)) {
				return;
			}
			const colorOpt = color_option_id !== undefined && color_option_id !== null && String(color_option_id) !== ''
				? parseInt(color_option_id, 10)
				: null;
			for (let i in logo_images_options) {
				const row = logo_images_options[i];
				if (parseInt(row.location_id, 10) !== loc) {
					continue;
				}
				if (colorOpt !== null && !isNaN(colorOpt) && colorOpt > 0) {
					if (typeof row.option_id === 'undefined' || parseInt(row.option_id, 10) !== colorOpt) {
						continue;
					}
				}
				if (row.is_default) {
					return row.logo_id;
				}

				if (first_available_logo_id === undefined) {
					first_available_logo_id = row.logo_id;
				}
			}

			return first_available_logo_id;
		},

		get_variant_data: function () {
			return $('#variant-data-js').data('variant');
		},

		clear_logos: function () {
			$('svg .prodigy-product__gallery-logo-js').remove();
			$('svg .thumb-gallery-logo-js').remove();
		},

		get_logo_id: function () {
			let logo_id;
			let $container = $('.prodigy-logo-tool__container.opened');
			if (this.is_logo_swatches) {
				logo_id = $('.prodigy-product__logo-swatch-js:checked').val();
			} else {
				logo_id = $container.find('.prodigy-logo-values-js').val();
			}

			return logo_id;
		},

		get_logos_data_by_option: function (option_slug=null) {
			let options = [];
			if (
				prodigyProductBulk.is_active_logo_bulk &&
				typeof attribute_name !== 'undefined' &&
				attribute_name === null
			) {
				attribute_name = $('.bulk-container-js:visible').data('attribute');
			}

			if (!prodigyProduct.is_variants()) {
				const master_logos = $('#master-logo-locations-data-js');
				options = master_logos.data('locations');
			} else if (prodigyProduct.is_swatches()) {
				let selected_swatch = $('.has-logo-settings-js:checked');
				if (
					option_slug !== null &&
					prodigyProductBulk.is_active_logo_bulk
				){
					selected_swatch = $('.prodigy-product__swatch-js[data-slug="'+option_slug+'"]');
				}
				options = selected_swatch.data('logos');
			} else if (
				prodigyProductBulk.is_active_logo_bulk &&
				typeof attribute_name !== 'undefined' &&
				attribute_name === this.logo_attribute
			) {
				const $select_for_images = $('option[data-logos]').parent('select');
				if ($select_for_images.val() === '') {
					return [];
				}
				options = $select_for_images.find('option[value="' + $select_for_images.val() + '"]').data('logos');

				if (prodigyProductBulk.is_active_logo_bulk) {
					options = $select_for_images.find('option[value="' + option_slug + '"]').data('logos');
				}
			} else {
				const $select_for_images = $('option[data-logos]').parent('select');
				if ($select_for_images.val() === '') {
					return [];
				}
				options = $select_for_images.find('option[value="' + $select_for_images.val() + '"]').data('logos');
				if (
					option_slug !== null &&
					prodigyProductBulk.is_active_logo_bulk
				) {
					options = $select_for_images.find('option[value="' + option_slug + '"]').data('logos');
				}
			}

			return options;
		},

		get_not_required_locations: function (option_slug=null) {
			let logo_images_options = this.get_logos_data_by_option(option_slug);
			let new_locations = [];
			for (let i in logo_images_options) {
				if (!logo_images_options[i].location.required) {
					new_locations[i] = logo_images_options[i];
				}
			}

			return new_locations;
		},

		parse_price_amount: function (value) {
			if (typeof value === 'number') {
				return isNaN(value) ? 0 : value;
			}
			if (typeof value === 'string') {
				const normalized = value.replace(',', '.').replace(/[^0-9.\-]/g, '');
				const parsed = parseFloat(normalized);
				return isNaN(parsed) ? 0 : parsed;
			}
			const parsed = parseFloat(value);
			return isNaN(parsed) ? 0 : parsed;
		},

		refresh_product_price: function () {
			if (typeof prodigyProduct === 'undefined' || prodigyProductBulk.is_active_logo_bulk) {
				return;
			}

			if (prodigyProduct.is_variants()) {
				prodigyProduct.set_variants_data(this.get_variant_data());
			} else {
				prodigyProduct.show_master_variant_info();
			}

			if (prodigyProductBulk.is_active_bulk) {
				const bulk_data = $('#variant-data-js').data('bulk-variants');
				if (bulk_data) {
					prodigyProductBulk.update_bulk_price(bulk_data);
				}
			}
		},

		is_required_location_charge_disabled: function ($locationSelect, $currentOption) {
			if (!$locationSelect || !$locationSelect.length || !$currentOption || !$currentOption.length) {
				return false;
			}

			const requiredModeRaw = $locationSelect.attr('data-required-mode');
			const selectedLocationRequiredRaw = $currentOption.attr('data-required');
			const isSelectedLocationRequired = selectedLocationRequiredRaw === 1 ||
				selectedLocationRequiredRaw === '1' ||
				selectedLocationRequiredRaw === true ||
				selectedLocationRequiredRaw === 'true';
			const isRequiredModeDisabled = requiredModeRaw === false ||
				requiredModeRaw === 0 ||
				requiredModeRaw === '0' ||
				requiredModeRaw === 'false';

			return isRequiredModeDisabled && isSelectedLocationRequired;
		},

		get_logos_price: function () {
			let self = this;
			let total_price = 0;

			if (this.is_logo_swatches) {
				$('.prodigy-logo-tool__container.opened .prodigy-product__logo-swatch-js:checked').each(function () {
					total_price += self.parse_price_amount($(this).data('price'));
				});
			} else {
				$('.prodigy-logo-tool__container.opened .prodigy-logo-values-js').each(function () {
					const $current_option = $(this).find('option[value=' + $(this).val() + ']');
					total_price += self.parse_price_amount($current_option.data('price'));
				});
			}

			return parseFloat(total_price);
		},

		get_location_price: function () {
			let self = this;
			let total_price = 0;

			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').each(function () {
				const $locationSelect = $(this);
				const $current_option = $locationSelect.find('option[value=' + $locationSelect.val() + ']');

				total_price += self.parse_price_amount($current_option.data('price'));
				if (!self.is_required_location_charge_disabled($locationSelect, $current_option)) {
					total_price += self.parse_price_amount($locationSelect.data('extra-charge'));
				}
			});

			return parseFloat(total_price);
		},

		get_extra_charge_for_index: function ($locationSelect, locationIndex) {
			if (!$locationSelect || !$locationSelect.length) {
				return 0;
			}
			const mode = String($locationSelect.data('mlc-mode') || '');
			if (!mode) {
				return parseFloat($locationSelect.data('extra-charge')) || 0;
			}
			if (mode === 'additional_per_location') {
				if (locationIndex <= 0) {
					return 0;
				}
				return parseFloat($locationSelect.data('mlc-additional-charge')) || 0;
			}
			if (mode === 'custom_per_location') {
				let customAmounts = $locationSelect.data('mlc-custom-charges');
				if (typeof customAmounts === 'string') {
					try {
						customAmounts = JSON.parse(customAmounts);
					} catch (e) {
						customAmounts = [];
					}
				}
				if (!Array.isArray(customAmounts) || customAmounts.length === 0) {
					return 0;
				}
				const index = locationIndex < customAmounts.length ? locationIndex : customAmounts.length - 1;
				let raw = customAmounts[index];
				if (raw && typeof raw === 'object' && !Array.isArray(raw) && Object.prototype.hasOwnProperty.call(raw, 'amount')) {
					raw = raw.amount;
				}
				return parseFloat(raw) || 0;
			}
			return parseFloat($locationSelect.data('extra-charge')) || 0;
		},

		update_extra_location_charges: function () {
			let self = this;
			let slotIndex = 0;
			$('.prodigy-logo-tool__container.opened').each(function () {
				const $tool = $(this);
				if (
					!$tool.is(':visible') ||
					self.is_extra_brand_logo_tool_container($tool)
				) {
					return;
				}
				const $locationSelect = $tool.find('.prodigy-logo-location-js').first();
				if (!$locationSelect.length) {
					return;
				}
				const mode = String($locationSelect.data('mlc-mode') || '');
				if (!mode) {
					return;
				}
				// Count only visible non-required primary location rows.
				$locationSelect.attr('data-mlc-slot-index', String(slotIndex));
				let extraCharge = self.get_extra_charge_for_index($locationSelect, slotIndex);
				const $selectedLocation = $locationSelect.find('option:selected');
				if (self.is_required_location_charge_disabled($locationSelect, $selectedLocation)) {
					extraCharge = 0;
				}
				$locationSelect.attr('data-extra-charge', String(extraCharge));
				$locationSelect.data('extra-charge', extraCharge);

				const $label = $tool.find('.prodigy-location-extra-charge-js').first();

				if ($label.length) {
					$label.text('(+$' + prodigy_price_format(extraCharge) + ')');
				}
				slotIndex++;
			});
		},

		refresh_product_price_and_variant_info: function () {
			this.update_extra_location_charges();
			if (prodigyProduct.is_variants() && !prodigyProductBulk.is_active_logo_bulk) {
				prodigyProduct.set_variants_data(this.get_variant_data());
			} else {
				prodigyProduct.show_master_variant_info();
			}
		},

		set_logos_swatches: function (option_slug=null) {
			let self = this;
			self.clear_logos();

			$('.prodigy-logo-tool__container.opened').each(function () {
				const $tool = $(this);
				const images_logos_settings = self.get_logos_overlay_settings_for_container($tool, option_slug);
				const $checked_logo_radio = $tool.find('.prodigy-product__logo-swatch-js:checked');
				const default_logo_name = $checked_logo_radio.data('name');
				const $location_select = $tool.find('.prodigy-logo-location-js');
				const checked_logo_id = $checked_logo_radio.val();
				const location_id = $location_select.val();
				$tool.find('.swatch-logo-name-js').text(default_logo_name);
				const cid = parseInt(checked_logo_id, 10);
				const lid = parseInt(location_id, 10);
				for (let i in images_logos_settings) {
					const row = images_logos_settings[i];
					if (parseInt(row.logo_id, 10) !== cid || parseInt(row.location_id, 10) !== lid) {
						continue;
					}
					let image_id = row.image_id;
					let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
					let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
					$current_image.parent('svg').append(self.create_logo_element(row));
					$current_thumb.closest('svg').append(self.create_logo_element(row));
				}
			});
		},

		set_logos: function (option_slug=null) {
			let self = this;
			self.clear_logos();
			$('.prodigy-logo-tool__container.opened').each(function () {
				const $tool = $(this);
				const images_logos_settings = self.get_logos_overlay_settings_for_container($tool, option_slug);
				const $logo_select = $tool.find('.prodigy-logo-values-js');
				const $location_select = $tool.find('.prodigy-logo-location-js');
				const logo_id = $logo_select.val();
				const location_id = $location_select.val();
				const gid = parseInt(logo_id, 10);
				const lid = parseInt(location_id, 10);

				for (let i in images_logos_settings) {
					const row = images_logos_settings[i];
					if (parseInt(row.logo_id, 10) !== gid || parseInt(row.location_id, 10) !== lid) {
						continue;
					}
					let image_id = row.image_id;
					let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
					let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
					$current_image.parent('svg').append(self.create_logo_element(row));
					$current_thumb.closest('svg').append(self.create_logo_element(row));
				}
			});
		},

		get_logos_data: function () {
			return  JSON.parse($('#product-options-data-js').val());
		},

		get_logo_options: function (variants) {
			let self = this;
			let product_options = self.get_logos_data();
			let active_bulk_attribute = $('.bulk-container-js:visible').data('attribute');
            if (typeof variants['logo_options_ids'] !== 'undefined') {
                variants['logo_options_ids'] = [];
            }
			if (
                prodigyProduct.is_variants() &&
                prodigyProduct.is_bulk_opened() &&
                active_bulk_attribute === self.logo_attribute
            ) {
				let current_options = self.filter_actual_options(prodigyProduct.get_bulk_options(self.logo_attribute), variants);
				$('.prodigy-logo-tool__container.opened').each(function () {
					let $container = $(this);
					let location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
					let current_logo_id = self.is_logo_swatches ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').val();

					if (self.is_extra_brand_logo_tool_container($container)) {
						const overlay = self.get_logos_overlay_settings_for_container($container);
						if (!overlay || typeof overlay !== 'object') {
							return;
						}
						// Overlay from API is an object keyed by logo-option relation id; [] means empty.
						if (Array.isArray(overlay)) {
							return;
						}
						for (let index in current_options) {
							if (!Object.prototype.hasOwnProperty.call(current_options, index)) {
								continue;
							}
							if (typeof variants[index]['logo_options_ids'] === 'undefined') {
								variants[index]['logo_options_ids'] = [];
							}
							for (const relId in overlay) {
								if (!Object.prototype.hasOwnProperty.call(overlay, relId)) {
									continue;
								}
								const row = overlay[relId];
								if (!row || typeof row.option_id === 'undefined') {
									continue;
								}
								if (
									parseInt(row.option_id, 10) === parseInt(current_options[index].id, 10) &&
									parseInt(row.location_id, 10) === parseInt(location_id, 10) &&
									parseInt(row.logo_id, 10) === parseInt(current_logo_id, 10)
								) {
									const rid = parseInt(relId, 10);
									if (variants[index]['logo_options_ids'].indexOf(rid) === -1) {
										variants[index]['logo_options_ids'].push(rid);
									}
								}
							}
						}
						return;
					}

					for (let index in current_options) {
						if (typeof variants[index]['logo_options_ids'] === 'undefined') {
							variants[index]['logo_options_ids'] = [];
						}
						for (let key in product_options[self.logo_attribute]) {
							if (current_options[index].name !== key || typeof product_options[self.logo_attribute][key]['logos'] === 'undefined') {
								continue;
							}
							for (let i in product_options[self.logo_attribute][key]['logos']) {
								if (
									parseInt(product_options[self.logo_attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
									parseInt(product_options[self.logo_attribute][key]['logos'][i]['location_id']) === parseInt(location_id) &&
									parseInt(product_options[self.logo_attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id)
								) {
                                    if (typeof variants['logo_options_ids'] === 'undefined') {
                                        variants['logo_options_ids'] = [];
                                    }
									variants[index]['logo_options_ids'].push(parseInt(i));
									delete product_options[self.logo_attribute][key]['logos'][i];
								}
							}
						}
					}
				});
			} else if (active_bulk_attribute !== self.logo_attribute) {
				$('.prodigy-logo-tool__container.opened').each(function () {
					const $container = $(this);
					const logo_id = self.is_logo_swatches ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').val();
					let location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
					const selectedColorOptionId = self.getSelectedLogoColorOptionId();
					if (typeof variants.length === 'undefined') {
						const images_logos_settings = self.get_logos_overlay_settings_for_container($container);
						for (let i in images_logos_settings) {
							const row = images_logos_settings[i];
							if (!row) {
								continue;
							}
							if (selectedColorOptionId > 0) {
								if (typeof row.option_id === 'undefined') {
									continue;
								}
								if (parseInt(row.option_id, 10) !== parseInt(selectedColorOptionId, 10)) {
									continue;
								}
							}
							if (
								parseInt(row.logo_id) === parseInt(logo_id) &&
								parseInt(row.location_id) === parseInt(location_id)
							) {
                                if (typeof variants['logo_options_ids'] === 'undefined') {
                                    variants['logo_options_ids'] = [];
                                }
								variants['logo_options_ids'].push(parseInt(i));
								break;
							}
						}
					} else {
						let color_option_slug = $('.attribute_values_js[data-slug="color"] option:selected').data('slug');

						if (self.is_swatches()) {
							color_option_slug = $('.prodigy-product__swatch-js[data-attribute="color"]:checked').data('slug');
						}
						if (variants.length >= 1 || prodigyProductBulk.is_bulk()) {
							for (let index in variants) {
								if (typeof variants[index]['logo_options_ids'] === 'undefined') {
									variants[index]['logo_options_ids'] = [];
								}
								for (let i in product_options[self.logo_attribute][color_option_slug]['logos']) {
									if (
										parseInt(product_options[self.logo_attribute][color_option_slug]['logos'][i]['location_id']) === parseInt(location_id) &&
										parseInt(product_options[self.logo_attribute][color_option_slug]['logos'][i]['logo_id']) === parseInt(logo_id)
									) {
                                        if (typeof variants['logo_options_ids'] === 'undefined') {
                                            variants['logo_options_ids'] = [];
                                        }
										variants[index]['logo_options_ids'].push(parseInt(i));
									}
								}
							}
						}
					}
				});
			}

			return variants;
		},

		is_swatches: function () {
			return $(this.prodigy_product_swatch_block_element).length !== 0;
		},

		filter_actual_options: function (current_options, variants) {
			let variant_options = [];
			let filtered_options = [];

			if (variants.length > 0) {
				for (let index in variants) {
					for (let index_option in variants[index].attributes.options) {
						if (variants[index].attributes.options[index_option].property_slug === this.logo_attribute) {
							variant_options.push(variants[index].attributes.options[index_option].option_slug);
						}
					}
				}

				for (let key in current_options) {
					if (variant_options.includes(current_options[key].name)) {
						filtered_options.push(current_options[key]);
					}
				}
			}

			return filtered_options;
		},

		get_selected_locations_list: function ($excluded_location_select) {
			let location_ids = [];
			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').not($excluded_location_select).each(function () {
				location_ids.push(parseInt($(this).val()));
			});

			return location_ids;
		},

		create_logo_element: function (logo_settings) {
			const logoAttrs = logo_settings.logo || {};
			const href = logoAttrs['original-url'] || (logoAttrs.attributes && logoAttrs.attributes['original-url']);
			if (!href || !logo_settings.location) {
				return $();
			}
			let $logo = $(document.createElementNS('http://www.w3.org/2000/svg', 'image'));
			$logo.addClass('prodigy-product__gallery-logo-js');
			$logo.attr('data-logo-id', logo_settings.logo_id);
			$logo.attr('data-location-id', logo_settings.location_id);
			$logo.attr('href', href);
			$logo.attr('width', logo_settings.location['width']);
			$logo.attr('height', logo_settings.location['height']);
			$logo.attr('x', logo_settings.location['x']);
			$logo.attr('y', logo_settings.location['y']);

			let transformX = logo_settings.location['x'] + (logo_settings.location['width'] / 2);
			let transformY = logo_settings.location['y'] + (logo_settings.location['height'] / 2);
			let logo_style = 'transform-origin:' + transformX + 'px ' + transformY + 'px; transform: rotate(' + logo_settings.location['angle'] + 'deg) rotateY(' + logo_settings.location['rotation-y'] + 'deg) rotateX(' + logo_settings.location['rotation-x'] + 'deg)';
			$logo.attr('style', logo_style);

			return $logo;
		},

		get_max_add_logo_forms: function (option_slug=null) {
			let self = this;
			const images_logos_settings = self.get_logos_data_by_option(option_slug);

			let logo_images = new Set();
			for (let i in images_logos_settings) {
				logo_images.add(images_logos_settings[i].location_id);
			}

			return logo_images.size;
		},

		make_uid: function () {
			this.uid_seq = (this.uid_seq || 0) + 1;
			return 'logo-' + Date.now() + '-' + this.uid_seq;
		},

		wire_logo_block_ids: function (root, uid) {
			const $scope = (root && root.jquery) ? root : $(root || []);
			if (!$scope.length || !uid) return;

			// If a DocumentFragment (nodeType 11), operate on its child elements
			const $ctx = ($scope[0] && $scope[0].nodeType === 11) ? $($scope[0].childNodes) : $scope;

			const $cb    = $ctx.find('.prodigy-logo-tool__input.toggle-form-js').first();
			const $label = $ctx.find('.prodigy-logo-tool__label').first();
			const $panel = $ctx.find('.prodigy-logo-tool__form-container').first();

			if ($cb.length) {
				$cb.attr({ id: uid, 'aria-controls': uid + '-panel', });
			}
			if ($label.length) {
				$label.attr('for', uid);
			}
			if ($panel.length) {
				$panel.attr({ id: uid + '-panel', });
			}

			var locId  = uid + '-locationselect';
			var logoId = uid + '-logoselect';
			const $loc = $ctx.find('.prodigy-logo-location-js').first();
			if ($loc.length) {
				$loc.attr({ id: locId });
				$loc.closest('.prodigy-product__logo-item')
					.find('label[for]').first().attr('for', locId);
			}

			const $logo = $ctx.find('.prodigy-logo-values-js').first();
			if ($logo.length) {
				$logo.attr({ id: logoId });
				$logo.closest('.prodigy-product__logo-item')
				.find('label[for]').first().attr('for', logoId);
			}
		},

		update_aria_attr: function (checkboxEl) {
			const $checkbox = $(checkboxEl);
			const panelId   = $checkbox.attr('aria-controls');
			const $panel    = panelId ? $('#' + panelId) : $(); // safe if missing
			const isOpen    = $checkbox.is(':checked');

			$checkbox.attr('aria-expanded', isOpen ? 'true' : 'false');

			if ($panel.length) {
				$panel.attr('aria-hidden', isOpen ? 'false' : 'true')
					.toggleClass('opened', isOpen)
					.toggleClass('closed', !isOpen);
			}

			return isOpen;
		},

		update_required_id: function (root) {
			const $ctx = (root && root.jquery) ? root : $(root || document);
			const self = this;

			$ctx.find('.container-js.required').each(function () {
				const $container = $(this);
				const uid = self.make_uid();
				self.wire_logo_block_ids($container, uid);
				$container.find('.prodigy-logo-tool__form-container').attr('aria-hidden', 'false');
			});
		},

		get_block_uid: function ($root) {
			const $r = ($root && $root.jquery) ? $root : $($root || []);
			if (!$r.length) {
				return this.make_uid();
			}
			let uid = $r.attr('data-swatchuid');
			if (!uid) {
				uid =
					$r.find('.prodigy-logo-tool__input.toggle-form-js').attr('id') ||
					(($r.find('.prodigy-logo-tool__form-container').attr('id') || '').replace(/-panel$/, '')) ||
					this.make_uid();
				$r.attr('data-swatchuid', uid);
			}
			return uid;
		},

		do_sanitize: function (s) {
			return String(s || '')
			.trim()
			.replace(/\s+/g, '_')
			.replace(/[^\w\-]/g, '_')
			.replace(/^_+|_+$/g, '');
		},

		rewire_swatch_ids: function (root) {
			const $scope = (root && root.jquery) ? root : $(root || document);
			const self   = this;

			const perBlockCount = new Map();

			$scope.find('.prodigy-product__logo-swatch-js').each(function () {
				const $input = $(this);
				const $block = $input.closest(
					'.prodigy-logo-tool__container, .prodigy-logo-tool__form-container'
				);
				// assigns data-swatchuid if missing
				const uid = self.get_block_uid($block);

				// get index for this block
				const idx = perBlockCount.get(uid) || 0;
				perBlockCount.set(uid, idx + 1);

				const oldId = $input.attr('id') || '';
				const base  = self.do_sanitize(($input.data('name') || '') + '_' + ($input.val() || 'logo'));

				let newId = uid + '-sw-' + base + '-' + idx;

				// ensure global uniqueness (just in case)
				let bump = 1;
				while (document.getElementById(newId)) {
				  if (oldId === newId) break;             // already ours
				  newId = uid + '-sw-' + base + '-' + idx + '-' + (bump++);
				}

				if (oldId !== newId) {
				  $input.attr('id', newId);
				}

				// update the associated label’s "for"
				let $label = $input.next('label');
				if (!$label.length && oldId) {
				  $label = $block.find('label[for="' + oldId + '"]').first();
				}
				if (!$label.length) {
				  $label = $input.closest('.prodigy-radio__swatch-btn').find('label').first();
				}
				if ($label.length) {
				  $label.attr('for', newId);
				}
			});
		},

		setExtraBrandLoadingUi: function ($container, isLoading) {
			const $row = $container.closest('.prodigy-logo-tool__container.container-js');
			if (!$row.length) {
				return;
			}
			if (isLoading) {
				$row.addClass('prodigy-extra-brand-loading');
				$row.attr('aria-busy', 'true');
			} else {
				$row.removeClass('prodigy-extra-brand-loading');
				$row.attr('aria-busy', 'false');
			}
		},

		getSelectedLogoColorOptionId: function () {
			let resolved = 0;
			if (typeof prodigyProduct !== 'undefined' && prodigyProduct.is_variants()) {
				const attr = this.logo_attribute;
				if (this.is_swatches()) {
					let $sw = $('.prodigy-product__swatch-block-js:not(.ignored) .prodigy-product__swatch-js[data-attribute="' + attr + '"]:checked').first();
					if (!$sw.length) {
						$sw = $('.prodigy-product__swatch-js[data-attribute="' + attr + '"]:checked').first();
					}
					if ($sw.length) {
						let oid = $sw.data('option-id');
						if (oid !== undefined && oid !== null && oid !== '') {
							const parsed = parseInt(oid, 10);
							resolved = isNaN(parsed) ? 0 : parsed;
						}
						if (!resolved) {
							const v = $sw.val();
							if (v !== undefined && v !== null && String(v).match(/^\d+$/)) {
								resolved = parseInt(v, 10);
							}
						}
					}
				} else {
					const $sel = $('.attribute_values_js[data-slug="' + attr + '"]');
					if ($sel.length) {
						const oid = $sel.find('option:selected').data('option-id');
						if (oid !== undefined && oid !== null && oid !== '') {
							const parsed = parseInt(oid, 10);
							resolved = isNaN(parsed) ? 0 : parsed;
						}
					}
				}
			}
			if (!resolved || resolved <= 0) {
				resolved = this.getColorOptionIdFromProductOptionsData();
			}
			return resolved;
		},

		/**
		 * Reload extra-brand markup when the selected color (variant option) changes while the block is open.
		 */
		syncExtraBrandWithSelectedColor: function () {
			let self = this;
			const $root = $(self.main_logo_management_container).filter('[data-extra-brand-mode="1"]');
			if (!$root.length) {
				return;
			}
			const $extraRow = $root.children('.prodigy-logo-tool__container.container-js').first();
			const $toggle = $extraRow.find('.toggle-form-js').first();
			if (!$toggle.is(':checked')) {
				return;
			}
			const $slot = $extraRow.find('.prodigy-logo-extra-brand-block-js').first();
			if (!$slot.length || !$slot.data('loaded') || $slot.data('loading')) {
				return;
			}
			$slot.removeData('loaded');
			self.loadExtraBrandLogoHtml($extraRow, $toggle, function () {
				self.set_logo_showing_type();
				self.disable_selected_location();
				if (self.is_logo_swatches) {
					if (typeof prodigyProductBulk !== 'undefined' && !prodigyProductBulk.is_active_logo_bulk) {
						self.refreshNonBulkLogoSwatchVisibility();
					}
					self.set_logos_swatches();
				} else {
					self.set_logos();
				}
				self.refresh_product_price_and_variant_info();
			}, true);
		},

		loadExtraBrandLogoHtml: function ($container, $checkbox, onDone, forceReload) {
			let self = this;
			if (!self.is_extra_brand_url_scoped_mode($container)) {
				if (typeof onDone === 'function') {
					onDone();
				}
				return;
			}
			const $slot = $container.find('.prodigy-logo-extra-brand-block-js').first();
			if (forceReload) {
				$slot.removeData('loaded');
			}
			if (!$slot.length || $slot.data('loading')) {
				if (typeof onDone === 'function') {
					onDone();
				}
				return;
			}
			if (!forceReload && $slot.data('loaded')) {
				if (typeof onDone === 'function') {
					onDone();
				}
				return;
			}
			const colorOptionId = self.getSelectedLogoColorOptionId();
			$slot.data('loading', true);
			self.setExtraBrandLoadingUi($container, true);
			$.post(
				$slot.data('ajax-url'),
				{
					action: 'prodigy-public-get-extra-brand-logo-html',
					nonce: $slot.data('nonce'),
					remote_product_id: $slot.data('remote-product-id'),
					secondary_brand_id: String($slot.data('extra-brand-id')),
					logo_swatches: $slot.data('logo-swatches') === 1 || $slot.data('logo-swatches') === '1' ? '1' : '0',
					color_option_id: String(colorOptionId),
				},
				function (response) {
					$slot.data('loading', false);
					self.setExtraBrandLoadingUi($container, false);
					if (!response || !response.success || !response.data || !response.data.html) {
						$checkbox.prop('checked', false);
						if (typeof window !== 'undefined' && window.console && console.warn) {
							console.warn('Extra brand logo load failed', response);
						}
						return;
					}
					$slot.html(response.data.html);
					$slot.data('loaded', true);
					self.set_logo_showing_type();
					const uid = self.make_uid();
					self.wire_logo_block_ids($slot, uid);
					self.rewire_swatch_ids($slot);
					self.set_custom_logo_select();
					self.set_custom_location_select();
					const locId = response.data.default_location_id;
					const logoId = response.data.default_logo_id;
					if (locId) {
						const $loc = $slot.find('.prodigy-logo-location-js').first();
						$loc.val(String(locId));
						self.refresh_ms_location_dropdown($loc);
					}
					if (logoId) {
						if (self.is_logo_swatches) {
							const $sw = $slot.find('.prodigy-product__logo-swatch-js[value="' + String(logoId) + '"]');
							if ($sw.length) {
								$sw.prop('checked', true);
								const nm = $sw.data('name');
								if (nm) {
									$slot.find('.swatch-logo-name-js').first().text(nm);
								}
							}
						} else {
							const $logoSel = $slot.find('.prodigy-logo-values-js').first();
							if ($logoSel.length) {
								$logoSel.val(String(logoId));
								self.refresh_ms_logo_dropdown($logoSel);
							}
						}
					}
					if (typeof onDone === 'function') {
						onDone();
					}
				},
				'json'
			).fail(function () {
				$slot.data('loading', false);
				self.setExtraBrandLoadingUi($container, false);
				$checkbox.prop('checked', false);
			});
		},

		show_logo_form: function () {
			let self = this;
			$(document).on('click', self.toggle_checkbox_selector, function () {
				let $container = $(this).closest('.container-js');
				let $location_select = $container.find('.prodigy-logo-location-js');
				const $extraSlot = $container.find('.prodigy-logo-extra-brand-block-js');
				const isExtraBrandScoped = self.is_extra_brand_url_scoped_mode($container);

				if (
					isExtraBrandScoped &&
					$(this).is(':checked') &&
					$extraSlot.length &&
					!$extraSlot.data('loaded') &&
					!$extraSlot.data('loading')
				) {
					const $cb = $(this);
					$cb.prop('checked', false);
					self.loadExtraBrandLogoHtml($container, $cb, function () {
						$cb.prop('checked', true);
						self.update_aria_attr($cb[0]);
						$container.removeClass('closed');
						$container.addClass('opened');
						self.set_logo_showing_type();
						self.disable_selected_location();
						if (self.is_logo_swatches) {
							if (typeof prodigyProductBulk !== 'undefined' && !prodigyProductBulk.is_active_logo_bulk) {
								self.refreshNonBulkLogoSwatchVisibility();
							}
							self.set_logos_swatches();
						} else {
							self.set_logos();
						}
						self.refresh_product_price_and_variant_info();
						if (prodigyProductBulk.is_active_logo_bulk) {
							$(document).trigger('enable-multiple-quantity');
						}
					});
					return;
				}

				const isOpen = self.update_aria_attr(this);

				if ($(this).is(':checked')) {
					const logo_images_options = self.get_not_required_locations();
					$container.removeClass('closed');
					$container.addClass('opened');
					if ($(document).find('.prodigy-logo-location-js').length < self.get_max_add_logo_forms()) {
						let $clone = $(self.template_selector).contents().clone();
						const uid = self.make_uid();self.wire_logo_block_ids($clone, uid);
						self.rewire_swatch_ids($clone);
						$(this).closest(self.main_logo_management_container).append($clone);
						self.set_custom_logo_select();
					}

					if (logo_images_options.length === 0) {
						self.hide_all_logo_blocks();
					}
					let preselected_location_ids = self.get_selected_locations_list($location_select);
					self.refresh_locations_list($location_select, logo_images_options, preselected_location_ids);
					self.preselect_logo_by_location($container, logo_images_options, $location_select.val());
					self.disable_selected_location();
				} else {
					self.enable_selected_location($location_select.val());
					if (isExtraBrandScoped && $extraSlot.length) {
						$extraSlot.removeData('loaded');
						$extraSlot.removeData('loading');
						$extraSlot.empty();
					}
					if ($container.is('.container-js:last-of-type')) {
						$container.removeClass('opened');
						$container.addClass('closed');
					} else {
						$container.remove();
					}
				}

				if (self.is_logo_swatches) {
					self.set_logos_swatches();
				} else {
					self.set_logos();
				}
				self.update_extra_location_charges();
				self.refresh_product_price();

				if (prodigyProductBulk.is_active_logo_bulk) {
					$(document).trigger('enable-multiple-quantity');
				}
			});

			$(document).on('keydown', self.toggle_checkbox_selector, function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		},


		bulk_logo_validate: function (attribute, current_options) {
			let product_options = this.get_logos_data();
			let self = this;

			$('.prodigy-logo-tool__container.opened').each(function () {
				const $container = $(this);
				let logos = [];
				const current_location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();

				if (self.is_extra_brand_logo_tool_container($container)) {
					const overlay_raw = self.get_logos_overlay_settings_for_container($container);
					const rows = Array.isArray(overlay_raw) ? overlay_raw : Object.values(overlay_raw || {});
					for (const index in current_options) {
						if (!Object.prototype.hasOwnProperty.call(current_options, index)) {
							continue;
						}
						for (let r = 0; r < rows.length; r++) {
							const row = rows[r];
							if (!row || typeof row.option_id === 'undefined') {
								continue;
							}
							if (
								parseInt(row.option_id, 10) === parseInt(current_options[index].id, 10) &&
								parseInt(row.location_id, 10) === parseInt(current_location_id, 10)
							) {
								logos.push(parseInt(row.logo_id, 10));
							}
						}
					}
					logos = [...new Set(logos)];
				} else {
					for (const index in current_options) {
						if (!Object.prototype.hasOwnProperty.call(current_options, index)) {
							continue;
						}
						for (const key in product_options[attribute]) {
							if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === 'undefined') {
								continue;
							}
							for (const i in product_options[attribute][key]['logos']) {
								if (
									parseInt(product_options[attribute][key]['logos'][i]['option_id'], 10) === parseInt(current_options[index].id, 10) &&
									parseInt(product_options[attribute][key]['logos'][i]['location_id'], 10) === parseInt(current_location_id, 10)
								) {
									logos.push(parseInt(product_options[attribute][key]['logos'][i]['logo_id'], 10));
								}
							}
						}
					}
					logos = [...new Set(logos)];
				}

				self.bulk_logo_disable($container, logos);
				self.set_logo_bulk($container, attribute, current_options);
			});
		},

		set_logo_bulk: function ($container, attribute, current_options) {
			let current_location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
			let product_options = this.get_logos_data();
			let current_logo_id = this.is_logo_swatches ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').find('option:selected').val();

			if (this.is_extra_brand_logo_tool_container($container)) {
				const overlay_raw = this.get_logos_overlay_settings_for_container($container);
				const rows = Array.isArray(overlay_raw) ? overlay_raw : Object.values(overlay_raw || {});
				for (const index in current_options) {
					if (!Object.prototype.hasOwnProperty.call(current_options, index)) {
						continue;
					}
					for (let i = 0; i < rows.length; i++) {
						const row = rows[i];
						if (!row) {
							continue;
						}
						if (
							parseInt(row.option_id, 10) !== parseInt(current_options[index].id, 10) ||
							parseInt(row.location_id, 10) !== parseInt(current_location_id, 10)
						) {
							continue;
						}
						let image_id = row.image_id;
						let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
						let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
						if (
							parseInt(row.logo_id, 10) === parseInt(current_logo_id, 10) &&
							parseInt(row.location_id, 10) === parseInt(current_location_id, 10)
						) {
							$current_image.parent('svg').append(this.create_logo_element(row));
							$current_thumb.closest('svg').append(this.create_logo_element(row));
						}
					}
				}
				return;
			}

			for (let index in current_options) {
				for (const key in product_options[attribute]) {
					if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === 'undefined') {
						continue;
					}
					for (const i in product_options[attribute][key]['logos']) {
						if (
							parseInt(product_options[attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
							parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(current_location_id)
						) {
							// set logo
							let image_id = product_options[attribute][key]['logos'][i]['image_id'];
							let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
							let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
							if (
								parseInt(product_options[attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id) &&
								parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(current_location_id)
							) {
								$current_image.parent('svg').append(this.create_logo_element(product_options[attribute][key]['logos'][i]));
								$current_thumb.closest('svg').append(this.create_logo_element(product_options[attribute][key]['logos'][i]));
							}
						}
					}
				}
			}
		},

		bulk_logo_disable: function ($container, logos) {
			logos = (logos || []).map(function (x) {
				const n = parseInt(x, 10);
				return isNaN(n) ? null : n;
			}).filter(function (x) {
				return x !== null;
			});
			if (this.is_extra_brand_logo_tool_container($container) && this.is_logo_swatches && logos.length === 0) {
				$container.find('.prodigy-product__logo-swatch-js').each(function () {
					$(this).prop('disabled', false);
					$(this).closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
					$(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
				});
				return;
			}
			if (this.is_logo_swatches) {
				let current_logo = $container.find('.prodigy-product__logo-swatch-js:checked').val();
				if (!logos.includes(parseInt(current_logo, 10))) {
					$container.find('.prodigy-product__logo-swatch-js:checked').removeProp('checked');
				}
				$container.find('.prodigy-product__logo-swatch-js').each(function () {
					if (logos.includes(parseInt($(this).val(), 10))) {
						$(this).prop('disabled', false);
						$(this).closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
						$(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
					} else {
						$(this).prop('disabled', true);
						$(this).closest('.prodigy-tooltip-js').addClass('prodigy-logo__disabled');
						$(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').addClass('prodigy-logo__disabled-mobile');
					}
				});

				if (!logos.includes(parseInt(current_logo, 10))) {
					$container.find('.prodigy-product__logo-swatch-js:not(:disabled)').first().prop('checked', 'checked');
				}

				$('.prodigy-logo-tool__container.opened').each(function () {
					const $logo_radio = $(this).find('.prodigy-product__logo-swatch-js:checked');
					const default_logo_name = $logo_radio.data('name');
					$(this).closest('.prodigy-logo-tool__container').find('.swatch-logo-name-js').text(default_logo_name);
				});

			} else {
				$container.find('.prodigy-logo-values-js option').each(function () {
					$(this).prop('disabled', !logos.includes(parseInt($(this).val(), 10)));
				});

				if ($container.find('.prodigy-logo-values-js option:selected:disabled').length > 0) {
					const val = $container.find('.prodigy-logo-values-js option:not(:disabled)').first().val();
					this.set_logo_select_value($container.find('.prodigy-logo-values-js'), val);
				}
			}
		},

		set_bulk_logo_option_validate: function (attribute, current_options) {
			let self = this;
			let image_options = {};
			let product_options = self.get_logos_data();
			$('.prodigy-logo-tool__container.opened').each(function () {
				let $container = $(this);
				let location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
				let current_logo_id = self.is_logo_swatches ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js option:selected').val();

				for (let index in current_options) {
					for (const key in product_options[attribute]) {
						if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === 'undefined') {
							continue;
						}
						for (const i in product_options[attribute][key]['logos']) {
							if (
								parseInt(product_options[attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
								parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(location_id) &&
								parseInt(product_options[attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id)
							) {
								current_options[index].has_location = current_options[index].has_location || true;
								image_options[index] = current_options[index];
							} else {
								current_options[index].has_location = current_options[index].has_location || false;
							}
						}

					}
				}
			});

            prodigyProductGallery.set_gallery(image_options, attribute);
			this.bulk_options_disable(current_options);
		},

		bulk_options_disable: function (current_options) {
			for (let index in current_options) {
				let bulk_input = $('.prodigy-bulk-input-js[data-option=' + current_options[index].name + ']');
				if (current_options[index].has_location) {
					bulk_input.attr('disabled', false);
					bulk_input.closest('.prodigy-bulk__table-cell-body').removeClass('prodigy-bulk__table-cell-body--disabled');
				} else {
					bulk_input.val('');
					bulk_input.attr('disabled', true);
					bulk_input.closest('.prodigy-bulk__table-cell-body').addClass('prodigy-bulk__table-cell-body--disabled');
				}
			}
		},

		bulk_locations_validate: function () {
			const $openedLocationSelects = $('.prodigy-logo-tool__container.opened .prodigy-logo-location-js');
			if ($openedLocationSelects.length < 2) {
				return;
			}

			const selectedLocations = [];
			const selectedCounters = {};

			$openedLocationSelects.each(function () {
				const selectedId = parseInt($(this).val(), 10);
				selectedLocations.push(isNaN(selectedId) ? null : selectedId);
				if (!isNaN(selectedId)) {
					selectedCounters[selectedId] = (selectedCounters[selectedId] || 0) + 1;
				}
			});

			const occupiedLocations = new Set();

			$openedLocationSelects.each(function (index) {
				const $location_select = $(this);
				let selectedId = selectedLocations[index];

				if (
					selectedId === null ||
					occupiedLocations.has(selectedId) ||
					(selectedCounters[selectedId] || 0) > 1
				) {
					let fallbackId = null;
					$location_select.find('option').each(function () {
						const optionId = parseInt($(this).val(), 10);
						if (isNaN(optionId)) {
							return;
						}
						if (!occupiedLocations.has(optionId)) {
							fallbackId = optionId;
							return false;
						}
					});

					if (fallbackId !== null) {
						selectedId = fallbackId;
						$location_select.val(String(fallbackId));
					}
				}

				if (selectedId !== null) {
					occupiedLocations.add(selectedId);
				}
			});

			$openedLocationSelects.each(function () {
				const $location_select = $(this);
				const currentId = parseInt($location_select.val(), 10);
				const usedByOthers = new Set();

				$openedLocationSelects.not($location_select).each(function () {
					const otherId = parseInt($(this).val(), 10);
					if (!isNaN(otherId)) {
						usedByOthers.add(otherId);
					}
				});

				$location_select.find('option').each(function () {
					const optionId = parseInt($(this).val(), 10);
					if (isNaN(optionId)) {
						return;
					}
					$(this).prop('disabled', usedByOthers.has(optionId) && optionId !== currentId);
				});
			});
		},
	};

	$(document).ready(function () {
		product_logo_management.init();
	});
	window.product_logo_management_object = product_logo_management;

})(jQuery, window);
